import comp from "./UnitSelectionFeed";
import withLoader from "UIComponents/GqlWithLoader";
export default withLoader(comp);
